export default __webpack_public_path__ + "e0ead968a02fbde6d40de5be74653a55.svg";